<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pClBs4/tc-custom/9781642502978.jpg?1721442197801" alt="This image is the cover for the book Live with Intention"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Live with Intention
      </h1>
      <p class="bookDescription body article font2">
        <b>“A book of beauty, creativity, wisdom, and great good will. Her chapter on forgiveness alone is worth the price of the book.” —Hugo Prather, bestselling author of <i>Notes to Myself</i></b><br/><br/>Mary Anne Radmacher is among the most-quoted women writers of our day. Her wisdom is found on greeting cards, journals, calendars, Instagram and Pinterest, in broadcast news, sermons, ceremonies and commencement speeches.<br/><br/>This noted author, artist and teacher lost a dear one. As memorial to her friend her book became the manifesto for an intentional life for thousands of people. In <i>Live with Intention</i>, Radmacher shares the story of how she learned to live more robustly by watching how her courageous friend chose to die. People who keep Radmacher’s writings at the ready, say this writing is both inspiring and comforting. Extraordinary lessons are drawn from ordinary experiences. Rich in story, metaphor and poetry, <i>Live with Intention</i> explores with you what it means to live each day with purposeful intent:Understand what matters most for youDeepen what already makes your life richDetermine your unique way to make a difference<br/><br/><b>“<i>Live with Intention</i> is a pure gift . . . Pick up this gem and bask in insight after insight.” —David Kundtz, author of <i>The Art of Stopping</i></b><br/><br/><b>“<i>Live with Intention</i> gives us the tools to believe we can go after dreams and actually capture them.” —Pat Ballard, author of <i>10 Steps to Loving Your Body (No Matter What Size You Are)</i></b><br/><br/><b>“Beautiful, artistic, inspiring, and written from her heart.” —Dr. Patrick Williams, coauthor of <i>Becoming a Professional Life Coach</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Anne Radmacher
      </h2>
      
      <p class="authorDescription body article"><P><B>Mary Anne Radmacher</B>&#160;is a writer and an artist. She conducts workshops on living a full, creative, balanced life; teaches Internet writing seminars; and works with individual clients. She has been writing since she was a child, and she uses her writing to explore symbols and find meaning.</P><P>Among her special honors, she counts the respect of her peers and the friendship of children. She is the author of&#160;<I>Lean Forward into Your Life</I>&#160;and&#160;<I>Live Boldly</I>. She lives in the thriving university town of Gainesville, FL, in close proximity to amazing humans and fine dogs. Visit her online at www.maryanneradmacher.net.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15d3b7c4